<template>
  <div>
    <MobileNav v-if="commonStore.isMobile" />
    <DesktopNav v-if="commonStore.isDesktop" />
  </div>
</template>
<script setup lang="ts">
import { useCommonStore } from '@stores';
import DesktopNav from '@components/common/DesktopNav.vue';
import MobileNav from '@components/common/MobileNav.vue';
const commonStore = useCommonStore();
</script>

<style scoped lang="scss"></style>